<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="12"
      cy="6.75"
      rx="3.25"
      ry="3.65"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 21V13L7 11L10.15 12.85L12 15.25L13.85 12.85L17 11L19 13V21H5Z"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M12 12.4L10 13.45L12 20L14 13.45L12 12.4Z" class="fill" />
    <path
      d="M15.25 14.25H18.25"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BusinessPersonIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
